import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup ,Validators } from '@angular/forms';
import { CompanyContractService } from '../../shared/service/company-contract.service';
import { ServiceFeeTypeService } from '../../shared/service/service-fee-type.service';
declare var jquery :any;
declare var $:any;
declare var Swal:any;

import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-service-fee-type',
  templateUrl: './service-fee-type.component.html',
  styleUrls: ['./service-fee-type.component.css']
})
export class ServiceFeeTypeComponent implements OnInit {

  addForm: FormGroup;
  submitted_add = false;
  editForm : FormGroup;
  submitted_edit =false;
  companyContactList =[];
  currentId;

  constructor(
      private fb: FormBuilder,
      private spinner: NgxSpinnerService,
      private serviceFeeTypeService : ServiceFeeTypeService,
      private compService : CompanyContractService
  ) {

    this.addForm = fb.group({
      'name': ['', Validators.required],
      'note': [''],
      'company_contract_id': ['', Validators.required],
    });
    this.editForm = fb.group({
      'name': ['', Validators.required],
      'note': [''],
      'company_contract_id': ['', Validators.required],
      'id': ['', Validators.required],
    });
  }


  ngOnInit() {
    this.get()
    this.getCompanyContact()
  }

  openModelAdd()
  {
    this.addForm.patchValue({
      name: '',
      company_contract_id: ''
    });
    this.serviceFeeTypeItemList = []
    this.addServiceFeeTypeItemList()
    $('#modal_add').modal('show')
  }

  getCompanyContact(){
    this.companyContactList = [];
    this.compService.getCompContact().subscribe(data=>{
      this.companyContactList = data;
    });
  }
  
  serviceFeeTypeItemList = []
  addServiceFeeTypeItemList(){
    console.log('=== addServiceFeeTypeItemList ===')
    var serviceFeeTypeItem = {}
    serviceFeeTypeItem["conditions"] = ""
    serviceFeeTypeItem["period"] = ""
    serviceFeeTypeItem["period_e"] = ""
    serviceFeeTypeItem["time_unit"] = ""
    serviceFeeTypeItem["service_charge"] = 0
    this.serviceFeeTypeItemList.push(serviceFeeTypeItem)
  }

  removeServiceFeeTypeItemList(index){
    this.serviceFeeTypeItemList.splice(index,1);
  }

  changeConditions(value,item){
    if(value == "2"){
      item.service_charge = 0
    }
  }

  serviceFeeTypeList
  get(){
    this.spinner.show();
    this.serviceFeeTypeList = [];
    $("#company_contact_table").DataTable().clear().destroy();
    this.serviceFeeTypeService.getAll().subscribe(data=>{
      this.serviceFeeTypeList = data;
      console.log(this.serviceFeeTypeList);
      setTimeout(() => {
        $('#company_contact_table').DataTable({});
        this.spinner.hide();
      }, 10);
    },
    err => {
      this.spinner.hide();
      console.log(err);
      this.failDialog(err);
    });
  }

  addProcess(value){
    if(this.addForm.invalid){
      return;
    }
    value.serviceFeeTypeItemList = this.serviceFeeTypeItemList;
    this.spinner.show();
    this.serviceFeeTypeService.add(value).subscribe(res=>{
        $('#modal_add').modal('hide');
        this.successDialog();
        this.get();
    }, error => {
      console.log(error);
      this.spinner.hide();
      this.failDialog(error);
    });
  }

  add(value){
    var i = 0
    this.submitted_add = true
    this.serviceFeeTypeItemList.forEach(item=>{
      console.log(item);
      if(!item['conditions']){
        console.log('conditions')
        return;
      }
      if(!item['time_unit']){
        console.log('time_unit')
        return;
      }
      if((this.serviceFeeTypeItemList.length-1) == i){
        this.addProcess(value)
      }
      i++
    });
  }

   updateProcess(value){
      if(this.editForm.invalid){
        return;
      }
      value.serviceFeeTypeItemList = this.serviceFeeTypeItemList;
      this.spinner.show();
      this.serviceFeeTypeService.update(this.currentId, value).subscribe(res=>{
        $('#modal_edit').modal('hide');
          this.successDialog();
          this.get();
      }, error => {
        console.log(error);
        this.spinner.hide();
        this.failDialog(error);
      });
   }

   update(value){
    var i = 0
    this.submitted_edit = true
    this.serviceFeeTypeItemList.forEach(item=>{
      console.log(item);
      if(!item['conditions']){
        console.log('conditions')
        return;
      }
      if(!item['time_unit']){
        console.log('time_unit')
        return;
      }
      if((this.serviceFeeTypeItemList.length-1) == i){
        this.updateProcess(value)
      }
      i++
    });
  }

    openModelEdit(id)
    {
      this.currentId = id
      this.serviceFeeTypeItemList = []
      this.spinner.show();
      this.serviceFeeTypeService.getById(id).subscribe(data=>{
        console.log(data);
        this.editForm.patchValue({
          id: data['id'],
          name: data['name'],
          note: data['note'],
          company_contract_id: data['company_contract_id']
        });
        this.serviceFeeTypeItemList = data.serviceFeeTypeItemList

        this.serviceFeeTypeItemList.forEach(item=>{
          item['time_unit'] = ""+item['time_unit'];
        });

        $('#modal_edit').modal('show');
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.spinner.hide();
        this.failDialog(error);
      });
    }

    openModelDelete(id)
    {
      this.currentId = id;
      console.log(this.currentId);
      $('#modal_delete').modal('show');
    }

    deleteComapnyContact(){
      this.spinner.show();
      this.serviceFeeTypeService.delete(this.currentId).subscribe(res=>{
        $('#modal_delete').modal('hide');
        this.successDialog();
        this.get();
      }, error => {
        console.log(error);
        this.spinner.hide();
        this.failDialog(error);
      });
    }

   successDialog(){
    Swal.fire("ทำรายการสำเร็จ!", "", "success");
  }

  failDialog(msg){
    Swal.fire({
      type: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: msg
    })
  }


}
